
export type CreateTweetMediaRequestType = typeof CreateTweetMediaRequestType[keyof typeof CreateTweetMediaRequestType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTweetMediaRequestType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
} as const;
